import { useState } from 'react';
import classNames from 'classnames';
// import useTranslation from 'next-translate/useTranslation';
import styles from './BroadcasterIndex.module.scss';
import Tabs from '@/dls/Tabs/Tabs';
// import { logValueChange } from '@/utils/eventLogger';
import BroadcasterVideoHomeComponent from './BroadcasterVideoHomeComponent/BroadcasterVideoHomeComponent';
import BroadcasterVideoComponent from './BroadcasterVideoComponent/BroadcasterVideoComponent';
// import VideoPage from './BroadcasterPlayer/BroadcasterPlayer';
// import Sidebar from './BroadcasterSidebar/BroadcasterSidebar';
// import Playlist from './BroadcasterPlaylistComponent/BroadcasterPlaylist.Component';
import PlaylistGrid from './BroadcasterPlaylistComponent/BroadcasterPlaylist.Component';
import MediaPage from '../Posts/Posts';
import BroadcasterSocialMediaComponent from './BroadcasterSocialMediaComponent/BroadcasterSocialMedia';

enum View {
  Home = 'home',
  PlayList = 'playlist',
  Videos = 'videos',
  Posts = 'posts',
  SocialMedia = 'social-media',
}

type Props = {
  isHomepage?: boolean;
};

const BroadcasterComponent: React.FC<Props> = () => {
  // const { t } = useTranslation('home');
  const [selectedTab, setSelectedTab] = useState(View.Home);

  const tabs = [];

  tabs.push({ title: "Home", value: View.Home });
  tabs.push({ title: "Playlist", value: View.PlayList });
  tabs.push({ title: "Videos", value: View.Videos });
  tabs.push({ title: "Posts", value: View.Posts });
  tabs.push({ title: "Social Media", value: View.SocialMedia });

  const onTabSelected = (newTab) => {
    // logValueChange('bookmark_section_and_collection', selectedTab, newTab);
    setSelectedTab(newTab);
  };

  return (
    <div>
      <div className={styles.mainWrapper}>
        {/* <Sidebar /> */}
        <div className={styles.rightSection}>
          <div className={styles.tabsContainer}>
            <Tabs tabs={tabs} selected={selectedTab} onSelect={onTabSelected} />
          </div>
          <div className={classNames(styles.contentContainer, styles.tabsContainer)}>
            {selectedTab === View.Posts && <MediaPage />}
            {selectedTab === View.Videos && <BroadcasterVideoComponent />}
            {selectedTab === View.PlayList && <PlaylistGrid />}
            {selectedTab === View.Home && <BroadcasterVideoHomeComponent />}
            {selectedTab === View.SocialMedia && <BroadcasterSocialMediaComponent />}
          </div>
        </div>
      </div>
    </div>

  );
};

export default BroadcasterComponent;
